import { getAuth } from 'firebase/auth'
import * as Sentry from '@sentry/browser'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { readResponseJson, getResponseDebugContext } from '@/util/api/response-body'
import { ApiError } from '@/util/errors/api-error'

/** Remove source-owned table rows while retaining the original matter file. */
export async function deleteTableSource(tableId: string, sourceId: string): Promise<void> {
  const token = await getAuth().currentUser?.getIdToken()
  if (!token) throw new Error('Sign in to access tables.')
  const url = `${kPaxtonAppApiRESTBaseUrl()}/api/v1/tables/${tableId}/sources/${sourceId}`
  const response = await fetch(url, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } })
  if (response.ok) return
  const { data } = await readResponseJson(response)
  const detail = data && typeof data === 'object' && 'detail' in data ? data.detail : undefined
  if (response.status >= 500) Sentry.captureException(new Error('Table source removal failed'), { extra: getResponseDebugContext(response, url) })
  throw new ApiError(
    response.status,
    response.status >= 400 && response.status < 500 && typeof detail === 'string'
      ? detail
      : 'Unable to remove this file. Refresh the source list and try again.'
  )
}
